import { Injectable } from '@angular/core';
import { FeatureRelease } from '../components/feature-releases/feature-release.model';

@Injectable()
export class FeatureReleaseService {
  private readonly featureReleases: FeatureRelease[] = [
    {
      Id: 1,
      Title: 'Asset X Export',
      Content: 'Allows exporting data to CSV and PDF formats with support for custom column selection.',
      Category: 'Data Export',
      UpdatedOn: new Date('2025-12-04'),
      Attachments: '',
      ActiveDays: 30,
      IsActive: true,
      CreatedBy: 'admin',
      CreatedDate: new Date('2025-11-01'),
      ModifiedBy: 'admin',
      ModifiedDate: new Date('2025-12-03'),
      IsForProPak: false,
      IsForClientDash: true,
      Tags: ['Reporting', 'Data']
    },
    {
      Id: 2,
      Title: 'New: Advanced Data Export',
      Content: 'Adds exporting data to CSV and PDF formats with templates and queued jobs for large datasets.',
      Category: 'Readiness',
      UpdatedOn: new Date('2025-12-15'),
      Attachments: '',
      ActiveDays: 15,
      IsActive: true,
      CreatedBy: 'readiness-admin',
      CreatedDate: new Date('2025-11-15'),
      ModifiedBy: 'readiness-admin',
      ModifiedDate: new Date('2025-12-10'),
      IsForProPak: false,
      IsForClientDash: true,
      Tags: ['Readiness', 'Reporting']
    },
    {
      Id: 3,
      Title: 'API Performance Boost',
      Content: 'Faster data retrieval endpoints for portfolio views with improved caching and pagination metadata.',
      Category: 'API Update',
      UpdatedOn: new Date('2025-12-15'),
      Attachments: '',
      ActiveDays: 20,
      IsActive: true,
      CreatedBy: 'api-owner',
      CreatedDate: new Date('2025-11-20'),
      ModifiedBy: 'api-owner',
      ModifiedDate: new Date('2025-12-12'),
      IsForProPak: true,
      IsForClientDash: true,
      Tags: ['API', 'Performance']
    },
    {
      Id: 4,
      Title: 'UX Readiness Improvements',
      Content: 'Better readability and spacing on readiness widgets plus improved empty states.',
      Category: 'UX',
      UpdatedOn: new Date('2025-11-18'),
      Attachments: '',
      ActiveDays: 45,
      IsActive: true,
      CreatedBy: 'ux-owner',
      CreatedDate: new Date('2025-10-20'),
      ModifiedBy: 'ux-owner',
      ModifiedDate: new Date('2025-11-18'),
      IsForProPak: false,
      IsForClientDash: true,
      Tags: ['UX', 'Readiness']
    },
    {
      Id: 5,
      Title: 'LLOG Integrations',
      Content: 'Connectivity updates for LLOG environments, including authentication handshake updates.',
      Category: 'Integration',
      UpdatedOn: new Date('2025-12-01'),
      Attachments: '',
      ActiveDays: 28,
      IsActive: true,
      CreatedBy: 'integration-owner',
      CreatedDate: new Date('2025-11-10'),
      ModifiedBy: 'integration-owner',
      ModifiedDate: new Date('2025-11-30'),
      IsForProPak: true,
      IsForClientDash: true,
      Tags: ['Integration', 'Security']
    },
    {
      Id: 6,
      Title: 'Expanded Retrieval Endpoints',
      Content: 'New analytics-friendly retrieval endpoints with filterable payloads and feature flags.',
      Category: 'API',
      UpdatedOn: new Date('2025-12-04'),
      Attachments: '',
      ActiveDays: 12,
      IsActive: true,
      CreatedBy: 'api-team',
      CreatedDate: new Date('2025-11-25'),
      ModifiedBy: 'api-team',
      ModifiedDate: new Date('2025-12-04'),
      IsForProPak: true,
      IsForClientDash: true,
      Tags: ['API', 'Analytics']
    },
    {
      Id: 7,
      Title: 'Enhanced User Roles',
      Content: 'Granular permission mapping for nested teams with approval workflows.',
      Category: 'Security',
      UpdatedOn: new Date('2025-12-20'),
      Attachments: '',
      ActiveDays: 5,
      IsActive: false,
      CreatedBy: 'security-owner',
      CreatedDate: new Date('2025-12-01'),
      ModifiedBy: 'security-owner',
      ModifiedDate: new Date('2025-12-19'),
      IsForProPak: true,
      IsForClientDash: true,
      Tags: ['Security', 'Admin']
    }
  ];

  getFeatures(): FeatureRelease[] {
    return [...this.featureReleases];
  }

  getFeatureById(id: number): FeatureRelease {
    return this.featureReleases.find((feature) => feature.Id === id);
  }

  getStatusClass(isActive: boolean): 'live' | 'inactive' {
    return isActive ? 'live' : 'inactive';
  }
}

